<template>

  <div class="vflex">
    <div class="vflex-row-0">
      
      <div style="max-width: 900px" class="p-3">
        <job-log-form
          :initValue="{}"
          @created="loadData"
          @updated="loadData">
          </job-log-form>
      </div>

    </div>
    <div class="vflex-row-1">

      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">

          <div style="max-width: 900px" class="p-3">
            <ul class="list-group feedlist">
              <job-log-item
                v-for="(jobLog, index) in jobLogs"
                :key="index"
                :jobLog="jobLog"
                @deleted="loadData">
                </job-log-item>
            </ul>
          </div>

        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

    </div>
  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import JobLogForm from './JobLogForm'
import JobLogItem from './JobLogItem'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'JobLog',
  components: {
    ThSort,
    JobLogForm,
    JobLogItem,
    Paginaty
  },
  props: [
  ],
  data () {
    return {
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at'
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    jobLogs () {
      return this.$store.getters.getJobLogs
    },
    paginate () {
      return this.$store.getters.getJobLogsPaginate
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    /*
    filters
    */
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit,
        job_id: this.job._id
      }

      this.$store
      .dispatch('selectJobLogs', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobLog/JobLog.vue